<template>
  <div class="lsjl-box">
    <div class="lsjl-top">
      <div class="lsjl-tabs">
        <div 
          :class="tabIndex === index ? 'lsjl-tab-active' : 'lsjl-tab'" 
          v-for="(item, index) in tabs" 
          :key="index" 
          @click="handleTabChange(index)"
        >
          {{item.name}}
        </div>
      </div>
      <div class="lsjl-date">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="-"
          :start-placeholder="$t('all.kaishiriqi')"
          :end-placeholder="$t('all.jieshuriqi')"
          value-format="yyyy-MM-dd"
          @change="handleDateChange"
          :picker-options="pickerOptions"
		  
        ></el-date-picker>
      </div>
    </div>
    <div class="lsjl-table">
      <div class="lsjl-table-header">
        <span class="lsjl-table-col lsjl-col-date">{{$t('all.riqi')}}</span>
        <span class="lsjl-table-col lsjl-col-type">{{$t('all.leixing')}}</span>
		<span class="lsjl-table-col lsjl-col-type">{{$t('all.miaoshu')}}</span>
        <span class="lsjl-table-col lsjl-col-amount">{{$t('all.jine')}}</span>
      </div>
      <div class="lsjl-table-body" ref="listContainer" @scroll="handleScroll" v-if="list.length > 0">
        <div class="lsjl-table-row" v-for="(item, index) in list" :key="index"
          :class="{'lsjl-table-row--clickable': isRowClickable(item)}"
          @click="handleRowClick(item)">
          <span class="lsjl-table-col lsjl-col-date">{{item.createTime}}</span>
          <span class="lsjl-table-col lsjl-col-type">{{item.billTypeName}}</span>
		  <span class="lsjl-table-col lsjl-col-type">{{item.billDesc}}</span>
          <span class="lsjl-table-col lsjl-col-amount" :class="item.amount > 0 ? 'lsjl-amount-green' : 'lsjl-amount-red'">
            {{item.amount > 0 ? '+' : ''}}{{item.amount}} {{item.currencyName}}
          </span>
        </div>
        <!-- <div class="lsjl-loading" v-if="isLoading">
          {{$t('all.jiazaihong')}}
        </div> -->
      </div>
      <div class="lsjl-table-empty" v-else>
        {{$t('all.zanwushuju')}}
      </div>
    </div>

    <!-- 充币/提币详情弹框（地址+复制） -->
    <div class="lsjl-overlay" v-if="showAddressModal" @click="showAddressModal = false"></div>
    <div class="lsjl-addr-modal" v-if="showAddressModal" @click.stop>
      <img class="lsjl-addr-close" src="../../../assets/image/tanchuang_x_b@2x.png" alt="" @click="showAddressModal = false" />
      <div class="lsjl-addr-title">{{addressModalTitle}}</div>
      <div class="lsjl-addr-card">
        <span class="lsjl-addr-label">{{addressModalLabel}}</span>
        <div class="lsjl-addr-right">
          <span class="lsjl-addr-value" :title="detailAddress">{{detailAddress}}</span>
          <img class="lsjl-addr-copy" src="../../../assets/image/fuzhi_18@2x.png" alt="" @click="copyDetailAddress" />
        </div>
      </div>
    </div>

    <!-- 提币被驳回弹框 -->
    <div class="lsjl-overlay" v-if="showRejectionModal" @click="showRejectionModal = false"></div>
    <div class="lsjl-rejection-modal" v-if="showRejectionModal" @click.stop>
      <img class="lsjl-rejection-close" src="../../../assets/image/tanchuang_x_b@2x.png" alt="" @click="showRejectionModal = false" />
      <!-- 顶部驳回图标 + 标题 -->
      <div class="lsjl-result-head">
        <img class="lsjl-result-icon" src="../../../assets/image/bohui_102@2x.png" alt="" />
        <div class="lsjl-result-title">{{$t('all.tibibeibohui')}}</div>
      </div>
      <!-- 状态卡片 -->
      <div class="lsjl-info-card">
        <span class="lsjl-info-card-label">{{$t('all.zhuangtai')}}</span>
        <span class="lsjl-info-card-value">{{rejectionItem.withdrawalStatusName || $t('all.shenhejujue')}}</span>
      </div>
      <!-- 驳回原因卡片 -->
      <div class="lsjl-reason-card">
        <span class="lsjl-reason-label">{{$t('all.bohuiyuanyin')}}{{getRejectionMsg(rejectionItem)}}</span>
      </div>
      <!-- 知道了按钮 -->
      <div class="lsjl-rejection-btn" @click="showRejectionModal = false">{{$t('all.zhidaole')}}</div>
    </div>
  </div>
</template>

<script>
import { getWalletBillTypeEnums,getWalletBalanceBillList } from "@/api/qianbao";
export default {
  data() {
    return {
      tabIndex: 0,
      tabs: [],
      dateRange: null,
      list: [],
      unitText: 'NB',
      hasMore: true,
      isLoading: false,
      queryParams: {
        page: 1,
        size: 20,
        type: 0,
		currencyId:this.$route.query.currencyId
      },
      pickerOptions: {},
      // 提币被驳回弹框
      showRejectionModal: false,
      rejectionItem: {},
      // 充币/提币详情弹框（地址+复制）
      showAddressModal: false,
      detailAddress: '',
      addressModalType: 'recharge'
    };
  },
  mounted() {
	this.getWalletBillTypeEnums()
    this.unitText = this.$route.query.unitText || 'NB';
    this.getList();
  },
  computed: {
    addressModalTitle() {
      return this.addressModalType === 'withdraw' ? this.$t('all.tibixiangqing') : this.$t('all.chongbixiangqing')
    },
    addressModalLabel() {
      return this.addressModalType === 'withdraw' ? this.$t('all.tibidizhi') : this.$t('all.chongbidizhi')
    }
  },
  methods: {
	async getWalletBillTypeEnums(){
	  const res = await getWalletBillTypeEnums()
	  this.tabs = res.data
	},
    handleTabChange(index) {
      this.tabIndex = index;
      this.queryParams.billType = this.tabs[index].type;
      this.queryParams.page = 1;
      this.hasMore = true;
      this.getList();
    },
    handleDateChange(val) {
      if (val) {
        this.queryParams.startDate = val[0];
        this.queryParams.endDate = val[1];
      } else {
        this.queryParams.startDate = '';
        this.queryParams.endDate = '';
      }
      this.queryParams.page = 1;
      this.hasMore = true;
      this.getList();
    },
    async getList() {
      if (this.isLoading || !this.hasMore) {
        return;
      }

      try {
        this.isLoading = true;
        const res = await getWalletBalanceBillList(this.queryParams);
        const newList = res.rows || res.data || [];

        if (this.queryParams.page === 1) {
          this.list = newList;
        } else {
          this.list = [...this.list, ...newList];
        }

        const totalPages = Math.ceil((res.total || 0) / this.queryParams.size);
        this.hasMore = this.queryParams.page < totalPages;
      } catch (error) {
        console.error("获取流水记录失败:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handleScroll() {
      if (this.isLoading || !this.hasMore) {
        return;
      }

      const container = this.$refs.listContainer;
      const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;

      if (isAtBottom) {
        this.queryParams.page++;
        this.getList();
      }
    },
    // 查看提币驳回原因
    handleShowRejection(item) {
      this.rejectionItem = item;
      this.showRejectionModal = true;
    },
    // 驳回原因：优先结构化字段，其次从billDesc中“驳回原因:”后解析
    getRejectionMsg(item) {
      if (item.withdrawalRejectionMsg) return item.withdrawalRejectionMsg
      const desc = item.billDesc || ''
      const matched = desc.match(/(?:驳回原因|駁回原因|Reason)\s*[:：]\s*([\s\S]*)/i)
      return matched ? matched[1].trim() : ''
    },
    // 行是否可点击：充币记录、提币记录(审核通过/审核驳回)
    isRowClickable(item) {
      const status = this.getWithdrawalStatus(item)
      if (status === 1 || status === 2) return true
      if (this.isRechargeRow(item) && this.getRowAddress(item)) return true
      return false
    },
    // 提币审核状态（兼容字符串/数字，缺失时从billDesc文本兜底判断）
    getWithdrawalStatus(item) {
      if (item.withdrawalStatus !== undefined && item.withdrawalStatus !== null && item.withdrawalStatus !== '') {
        return Number(item.withdrawalStatus)
      }
      // billDesc 文本兜底：驳回原因行=2，状态行含“通过/通過”=1，含“审核中/審核中”=0
      const desc = item.billDesc || ''
      if (/驳回原因|駁回原因|[Rr]eject/i.test(desc)) return 2
      if (/审核通过|審核通過|[Aa]pproved|審査通過|승인/.test(desc)) return 1
      if (/审核中|審核中|[Pp]ending|審査中|심사/.test(desc)) return 0
      return null
    },
    // 是否充币记录（类型名称与国际化“充币”一致）
    isRechargeRow(item) {
      return item.billTypeName === this.$t('all.chongbi')
    },
    // 行点击统一入口
    handleRowClick(item) {
      const status = this.getWithdrawalStatus(item)
      // 提币记录：2驳回→驳回原因弹框；1通过→提币地址弹框；0审核中不处理
      if (status === 2) {
        this.handleShowRejection(item)
        return
      }
      if (status === 1) {
        this.openAddressModal(item, 'withdraw')
        return
      }
      // 充币记录：显示充币地址
      if (this.isRechargeRow(item)) {
        this.openAddressModal(item, 'recharge')
      }
    },
    // 打开地址详情弹框
    openAddressModal(item, type) {
      const addr = this.getRowAddress(item)
      if (!addr) return
      this.addressModalType = type
      this.detailAddress = addr
      this.showAddressModal = true
    },
    // 取记录地址：优先结构化字段，其次从billDesc中提取
    getRowAddress(item) {
      const addr = item.address || item.rechargeAddress || item.withdrawAddress || item.withdrawalAddress || ''
      if (addr) return addr
      return this.extractAddress(item.billDesc)
    },
    // 从账单描述中提取地址：优先匹配“地址/Address/アドレス/주소: xxx”标签行，其次按链上格式兜底
    extractAddress(text) {
      if (!text) return ''
      const labeled = text.match(/(?:地址|Address|アドレス|주소)\s*[:：]\s*(\S+)/i)
      if (labeled && labeled[1]) return labeled[1]
      const evm = text.match(/0x[a-zA-Z0-9]{8,}/)
      if (evm) return evm[0]
      const tron = text.match(/\bT[a-zA-Z0-9]{33}\b/)
      if (tron) return tron[0]
      return ''
    },
    // 复制详情地址
    copyDetailAddress() {
      if (!this.detailAddress) return
      navigator.clipboard.writeText(this.detailAddress)
      this.$message.success(this.$t('all.fuzhichenggong'))
    }
  }
};
</script>

<style scoped lang="scss">
@import "./liushuijilu.css";

/deep/ .el-date-editor {
	background: rgba(255, 255, 255, 0.1) !important;
	border: none !important;
	border-radius: 38px !important;
	width: 360px !important;
}
/deep/ .el-date-editor .el-range-input {
	background: transparent !important;
	color: #FFFFFF !important;
}
/deep/ .el-date-editor .el-range-separator {
	color: rgba(255, 255, 255, 0.6) !important;
}
/deep/ .el-date-editor .el-range__icon {
	color: rgba(255, 255, 255, 0.6) !important;
}
/deep/ .el-date-editor .el-range__close-icon {
	color: rgba(255, 255, 255, 0.6) !important;
}
</style>
<style>
	.el-range-input{
		background: rgba(255,255,255,0.01);
		color: #ffffff;
	}
	.el-input__icon .el-range__close-icon{
		color: #ffffff;
	}
</style>


// WEBPACK FOOTER //
// liushuijilu.vue?3309fd30